module.exports = __webpack_public_path__ + "img/banner-with-sign.15882359.png";